export default {
  en: {
    'containers.table-expander.hide-details': 'Hide details',
    'containers.table-expander.show-details': 'Show details',
  },
};
